import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "MedicalWebPage",
   "@id": "https://www.futurefamilyai.com/family-planning/cystic-fibrosis-carrier-screening/#webpage",
   "url": "https://www.futurefamilyai.com/family-planning/cystic-fibrosis-carrier-screening/",
   "name": "Cystic Fibrosis Carrier Screening Explained | FutureFamilyAI",
   "description": "CF carrier screening looks for CFTR variants. Who's offered it, how common carriers are, and what a positive result means for family planning.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Family Planning & Carrier Screening",
     "item": "https://www.futurefamilyai.com/family-planning/carrier-screening/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Cystic Fibrosis Carrier Screening",
     "item": "https://www.futurefamilyai.com/family-planning/cystic-fibrosis-carrier-screening/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "How common is being a cystic fibrosis carrier?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "About 1 in 25 non-Hispanic white people; frequency is lower in many other ancestries."
     }
    },
    {
     "@type": "Question",
     "name": "If I'm a CF carrier, will my baby have CF?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Only if the other biological parent is also a carrier, and then the chance is 25% per pregnancy."
     }
    },
    {
     "@type": "Question",
     "name": "Is CF carrier screening recommended for everyone?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "ACOG recommends offering it to everyone considering pregnancy or currently pregnant."
     }
    },
    {
     "@type": "Question",
     "name": "What gene causes cystic fibrosis?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Variants in the CFTR gene."
     }
    },
    {
     "@type": "Question",
     "name": "Can carriers have symptoms?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Carriers usually have no symptoms."
     }
    },
    {
     "@type": "Question",
     "name": "What if we're both carriers?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "A genetic counselor will explain options such as IVF with embryo testing, donor gametes or prenatal testing."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function FamilyPlanningCysticFibrosisCarrierScreeningPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/family-planning/carrier-screening">
                Family Planning &amp; Carrier Screening
              </Link>
              <span>›</span>
              <span>Cystic Fibrosis Carrier Screening</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                Cystic fibrosis carrier screening checks for variants in the
                CFTR gene.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Planning couples</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      About 1 in 25 non-Hispanic white people carry a cystic
                      fibrosis variant; carrier frequency varies by ancestry.
                      (ACOG Committee Opinion No. 691, 2017)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Included in standard panels · Couple summary highlights
                      shared carriers · Counselor review available
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">FAMILY PLANNING GUIDE</span>
            <h1>
              Cystic Fibrosis Carrier Screening — What Couples Should Know
            </h1>
            <p className="ffh-answer speakable-content">
              Cystic fibrosis carrier screening checks for variants in the CFTR
              gene. About 1 in 25 non-Hispanic white people are carriers, with
              frequency varying by ancestry, and ACOG recommends offering CF
              screening to everyone considering pregnancy. If both partners are
              carriers, each pregnancy has a 25% chance of an affected child.
              Discuss residual risk with a genetic counselor. Learn about
              FutureFamilyAI screening.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=member"
              >
                Request Free Pilot Access
              </Link>
              <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Illustration representing cystic fibrosis carrier screening for couples"
              >
                <figcaption>
                  <b>Photo slot</b> · Abstract, calm editorial illustration: two
                  overlapping soft circles in brand blue and pink with a simple
                  DNA helix motif. No letters or labels.
                  <br />
                  <b>Alt:</b> Illustration representing cystic fibrosis carrier
                  screening for couples
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    About 1 in 25 non-Hispanic white people carry a cystic
                    fibrosis variant; carrier frequency varies by ancestry.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/committee-opinion/articles/2017/03/carrier-screening-for-genetic-conditions">
                        ACOG Committee Opinion No. 691, 2017
                      </a>
                    </cite>
                  </li>
                  <li>
                    ACOG recommends offering carrier screening for cystic
                    fibrosis and spinal muscular atrophy to everyone who is
                    considering pregnancy or is pregnant.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/committee-opinion/articles/2017/03/carrier-screening-for-genetic-conditions">
                        ACOG Committee Opinion No. 691, 2017
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>If both partners are carriers</h2>
                <ul>
                  <li>25% chance a child has CF</li>
                  <li>50% chance a child is a carrier</li>
                  <li>25% chance a child is neither</li>
                  <li>Options are discussed with a genetics professional</li>
                </ul>
              </section>
              <section id="s2">
                <h2>Residual risk</h2>
                <p>
                  No panel detects every CFTR variant; a negative result lowers
                  but doesn&apos;t remove risk.
                </p>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      How common is being a cystic fibrosis carrier?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        About 1 in 25 non-Hispanic white people; frequency is
                        lower in many other ancestries.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      If I&apos;m a CF carrier, will my baby have CF?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Only if the other biological parent is also a carrier,
                        and then the chance is 25% per pregnancy.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Is CF carrier screening recommended for everyone?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        ACOG recommends offering it to everyone considering
                        pregnancy or currently pregnant.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>What gene causes cystic fibrosis?</summary>
                    <div className="ffh-ans">
                      <p>Variants in the CFTR gene.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Can carriers have symptoms?</summary>
                    <div className="ffh-ans">
                      <p>Carriers usually have no symptoms.</p>
                    </div>
                  </details>
                  <details>
                    <summary>What if we&apos;re both carriers?</summary>
                    <div className="ffh-ans">
                      <p>
                        A genetic counselor will explain options such as IVF
                        with embryo testing, donor gametes or prenatal testing.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                  <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/family-planning/carrier-screening">
                    Family Planning &amp; Carrier Screening →
                  </Link>
                  <Link to="/family-planning/what-is-carrier-screening">
                    What Is Carrier Screening? →
                  </Link>
                  <Link to="/family-planning/carrier-screening-cost">
                    Carrier Screening Cost →
                  </Link>
                  <Link to="/family-planning/genetic-counseling-before-pregnancy">
                    Genetic Counseling Before Pregnancy →
                  </Link>
                  <Link to="/family-planning/carrier-screening-existing-results">
                    Existing Carrier Screening Results →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">If both partners are carriers</a>
                  </li>
                  <li>
                    <a href="#s2">Residual risk</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
